import { getFlowKey } from '../routing/getFlowKey';
export const enrollOnFlow = flows => {
  return flows.includes(getFlowKey());
};